import { formatDate } from '../utils/date-time';

export const dateFilter = (value: Date, format: string) => formatDate(value, format)
